<template>
    <section class="tw-rounded tw-p-5 tw-pb-0 tw-mt-5 post">
        <div class="tw-flex tw-items-center tw-mb-2">
            <v-img alt="user" :aspect-ratio="1/1" min-width="48" max-height="48" max-width="48" class="tw-border tw-border-solid tw-border-white tw-border-opacity-10 tw-rounded-full tw-flex-shrink" :src="pageOptions.logo.length ? pageOptions.logo : (artist.post_image.length ? artist.post_image : spotifyArtist.images[2].url)" />
            <div class="tw-flex tw-flex-col tw-text-white tw-font-sans tw-pl-2 tw-w-full tw-flex-shrink">
                <div @click="dialog = true" class="tw-rounded-full tw-px-5 tw-text-white tw-text-opacity-40 tw-bg-black tw-bg-opacity-10 tw-py-3 tw-w-full tw-text-xs tw-font-sans tw-cursor-pointer" v-ripple id="textPost">No que você está pensando?</div>
            </div>
        </div>
        <hr class="tw-mt-5 tw-opacity-10">
        <div class="tw-flex tw-w-full tw-justify-center tw-items-center tw-py-2">
            <div class="tw-w-1/2 md:tw-w-4/12 tw-flex tw-items-center tw-cursor-pointer tw-p-3 tw-justify-center tw-rounded" @click="handlePhotosClick()" v-ripple>
                <i class="fas fa-photo-video tw-text-blue-600 tw-mr-2"></i>
                <span class="tw-font-sans tw-text-white tw-text-opacity-40 tw-text-xs tw-uppercase tw-pointer-events-none">Fotos/vídeos</span>
            </div>
            <!-- <div class="tw-w-1/2 md:tw-w-4/12 tw-flex tw-items-center tw-cursor-pointer tw-p-3 tw-justify-center tw-rounded" v-ripple>
                <i class="fas fa-users tw-text-red-600 tw-mr-2"></i>
                <span class="tw-font-sans tw-text-white tw-text-opacity-40 tw-text-xs tw-uppercase tw-pointer-events-none">Crowdfunding</span>
            </div> -->
        </div>
        <v-dialog v-model="dialog" width="500">
            <v-card v-show="tab == 1">
                <div class="grey darken-4 tw-justify-center tw-text-base tw-font-sans tw-p-4 tw-w-full tw-flex">
                    <h3>
                        Criar publicação
                    </h3>
                </div>
                <div class="tw-p-5">
                    <div class="tw-flex tw-items-center">
                        <v-img alt="user" :aspect-ratio="1/1" max-height="40" max-width="40" class="tw-border tw-border-solid tw-border-white tw-border-opacity-10 tw-rounded-full" :src="artist.post_image.length ? artist.post_image : spotifyArtist.images[2].url" />
                        <div class="tw-flex tw-flex-col tw-text-white tw-font-sans tw-pl-2">
                            <h4 class="tw-m-0 tw-p-0 tw-font-bold tw-text-xs">{{artist.artista_nome}}</h4>
                            <a href="#" id="visibility" @click="tab = 2" v-ripple class="tw-bg-white tw-bg-opacity-10 tw-font-sans tw-text-white tw-rounded">
                                <i class="fas tw-mr-1" :class="{'fa-globe-americas': form.visibility == 'public', 'fa-key': form.visibility == 'subscriber', 'fa-user-check': form.visibility == 'follower', 'fa-shopping-bag': form.visibility == 'buyer'}"></i>
                                {{ form.visibility == 'public' ? 'Público' : form.visibility == 'subscriber' ? 'Assinantes' : form.visibility == 'follower' ? 'Seguidores' : 'Compradores' }}
                            </a>
                        </div> 
                    </div>
                    <v-textarea class="tw-mt-5 tw-font-sans" v-model="form.description" no-resize hide-details color="white" filled name="description" label="No que você está pensando?"></v-textarea>
                    <a href="#" @click="$refs.fileInput.click()" class="tw-inline-flex tw-mt-2 tw-rounded tw-px-4 tw-py-2" v-ripple>
                        <i class="fas fa-photo-video tw-mr-2"></i>
                        <span class="tw-text-white tw-text-opacity-80 tw-font-sans tw-text-xs">Adicionar à publicação</span>
                    </a>
                    <input type="file" class="tw-hidden" ref="fileInput" multiple accept="image/png, image/jpg, image/jpeg, video/mp4" @change="onFileChange">
                    <div class="tw-px-1">
                        <div class="tw-flex tw-flex-wrap tw--mx-2" v-if="files.length">
                            <div class="tw-w-4/12 tw-px-1 tw-py-2" v-for="(file, index) in files" :key="index">
                                <v-img :aspect-ratio="1/1" min-height="50" min-width="50" max-height="150" max-width="150" :src="file.url" class="tw-border tw-relative tw-rounded tw-border-solid tw-border-white tw-border-opacity-10 tw-bg-gray-900">
                                    <div style="font-size:0.5em" class="tw-font-sans tw-text-white tw-bg-black tw-bg-opacity-50 tw-absolute tw-top-0 tw-right-0 tw-mr-1 tw-mt-1 tw-px-2 tw-rounded-sm tw-py-1"><i class="fas" :class="{'fa-video': file.type == 'video', 'fa-camera': file.type == 'image'}"></i></div>
                                    <template v-slot:placeholder>
                                        <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                            </div>
                        </div>
                    </div>
                </div>
                <v-card-actions class="tw-p-5">
                    <v-btn light block @click="createPost()" :loading="loading">
                        Publicar
                    </v-btn>
                </v-card-actions>
                <v-progress-linear v-model="progress" v-if="loading" color="purple" height="3" />
            </v-card>
            <v-card v-show="tab == 2">
                <div class="grey darken-4 tw-justify-center tw-items-center tw-text-base tw-font-sans tw-p-4 tw-w-full tw-flex tw-relative">
                    <a href="#" @click="tab = 1" v-ripple class="tw-w-10 tw-h-10 tw-flex tw-absolute tw-left-0 tw-items-center tw-justify-center tw-text-white tw-bg-black tw-bg-opacity-10 tw-rounded-full tw-ml-3">
                        <i class="fas fa-arrow-left tw-absolute tw-opacity-40"></i>
                    </a>
                    <h3>
                        Selecionar público
                    </h3>
                </div>
                <div class="tw-p-5">
                    <h3 class="tw-font-sans tw-text-white tw-text-base">Quem pode ver sua publicação?</h3>
                    <v-radio-group v-model="form.visibility">
                        <div class="tw-flex tw-items-center tw-rounded tw-bg-gray-800 tw-bg-opacity-10 tw-p-2 tw-w-full tw-cursor-pointer tw-mb-4" v-ripple @click="$refs.radioPublic.$el.click()">
                            <div class="tw-w-12 tw-h-12 tw-bg-opacity-10 tw-bg-black tw-text-white tw-text-opacity-40 tw-text-lg tw-flex tw-relative tw-items-center tw-justify-center tw-rounded-full tw-flex-shrink-0">
                                <i class="fas fa-globe-americas tw-absolute"></i>
                            </div>
                            <div class="tw-flex tw-flex-col tw-font-sans tw-text-white tw-ml-3 tw-flex-shrink-0">
                                <p class="tw-m-0 tw-text-base">Público</p>
                                <p class="tw-m-0 tw-text-xs tw-opacity-40">Qualquer pessoa que acessar</p>
                            </div>
                            <div class="tw-flex tw-flex-col tw-font-sans tw-text-white tw-ml-3 tw-w-full tw-items-end">
                                <v-radio color="white" ref="radioPublic" value="public"></v-radio>
                            </div>
                        </div>
                        <div class="tw-flex tw-items-center tw-rounded tw-bg-gray-800 tw-bg-opacity-10 tw-p-2 tw-w-full tw-cursor-pointer tw-mb-2" v-ripple @click="$refs.radioFollower.$el.click()">
                            <div class="tw-w-12 tw-h-12 tw-bg-opacity-10 tw-bg-black tw-text-white tw-text-opacity-40 tw-text-lg tw-flex tw-relative tw-items-center tw-justify-center tw-rounded-full tw-flex-shrink-0">
                                <i class="fas fa-user-check tw-absolute"></i>
                            </div>
                            <div class="tw-flex tw-flex-col tw-font-sans tw-text-white tw-ml-3 tw-flex-shrink-0">
                                <p class="tw-m-0 tw-text-base">Seguidores</p>
                                <p class="tw-m-0 tw-text-xs tw-opacity-40">Qualquer pessoa que for seu seguidor</p>
                            </div>
                            <div class="tw-flex tw-flex-col tw-font-sans tw-text-white tw-ml-3 tw-w-full tw-items-end">
                                <v-radio color="white" ref="radioFollower" value="follower"></v-radio>
                            </div>
                        </div>
                        <div class="tw-flex tw-items-center tw-rounded tw-bg-gray-800 tw-bg-opacity-10 tw-p-2 tw-w-full tw-cursor-pointer tw-mb-4" v-if="options.subscriber" v-ripple @click="$refs.radioSubscriber.$el.click()">
                            <div class="tw-w-12 tw-h-12 tw-bg-opacity-10 tw-bg-black tw-text-white tw-text-opacity-40 tw-text-lg tw-flex tw-relative tw-items-center tw-justify-center tw-rounded-full tw-flex-shrink-0">
                                <i class="fas fa-key tw-absolute"></i>
                            </div>
                            <div class="tw-flex tw-flex-col tw-font-sans tw-text-white tw-ml-3 tw-flex-shrink-0">
                                <p class="tw-m-0 tw-text-base">Assinantes</p>
                                <p class="tw-m-0 tw-text-xs tw-opacity-40">Qualquer pessoa que for seu assinante</p>
                            </div>
                            <div class="tw-flex tw-flex-col tw-font-sans tw-text-white tw-ml-3 tw-w-full tw-items-end">
                                <v-radio color="white" ref="radioSubscriber" value="subscriber"></v-radio>
                            </div>
                        </div>
                        <!-- <div class="tw-flex tw-items-center tw-rounded tw-bg-gray-800 tw-bg-opacity-10 tw-p-2 tw-w-full tw-cursor-pointer" v-ripple @click="$refs.radioBuyer.$el.click()">
                            <div class="tw-w-12 tw-h-12 tw-bg-opacity-10 tw-bg-black tw-text-white tw-text-opacity-40 tw-text-lg tw-flex tw-relative tw-items-center tw-justify-center tw-rounded-full tw-flex-shrink-0">
                                <i class="fas fa-shopping-bag tw-absolute"></i>
                            </div>
                            <div class="tw-flex tw-flex-col tw-font-sans tw-text-white tw-ml-3 tw-flex-shrink-0">
                                <p class="tw-m-0 tw-text-base">Compradores</p>
                                <p class="tw-m-0 tw-text-xs tw-opacity-40">Qualquer pessoa que comprar a publicação</p>
                            </div>
                            <div class="tw-flex tw-flex-col tw-font-sans tw-text-white tw-ml-3 tw-w-full tw-items-end">
                                <v-radio color="white" ref="radioBuyer" value="buyer"></v-radio>
                            </div>
                        </div> -->
                    </v-radio-group>
                </div>
            </v-card>
        </v-dialog>
    </section>
</template>

<script>
import captureFrame from 'capture-frame';
import EventBus from '@/eventbus';
export default {
    props: ['artist', 'spotifyArtist', 'options', 'pageOptions'],
    data(){
        return{
            dialog: false,
            loading: false,
            progress: 0,
            tab: 1,
            files: [],
            form: {
                description: '',
                files: [],
                visibility: 'public',
            },
        }
    },
    methods:{
        onFileChange(e) {
            const vm = this;
            this.files = [];
            this.form.files = [];
            const files = e.target.files;
            var fileReader = new FileReader();
            Array.from(files).forEach(file => {
                this.form.files.push(file);
                var comps = file.name.split(".");
                if (comps.length === 1 || (comps[0] === "" && comps.length === 2)) {
                    return;
                }
                var ext = comps.pop().toLowerCase();
                
                if (ext == 'mov' || ext == 'mpeg' || ext == 'mp4' || ext == 'wmv') {
                    // create a hidden <video> element with video file.
                    var blob = new Blob([fileReader.result], {type: file.type});
                    var url = URL.createObjectURL(file);
                    var video = document.createElement('video');
                    video.addEventListener('canplay', onCanPlay)
                    video.volume = 0;
                    video.autoplay = true;
                    video.muted = true;
                    video.src = url;

                    console.log(video);
                    
                    function onCanPlay () {
                        video.removeEventListener('canplay', onCanPlay)
                        video.addEventListener('seeked', onSeeked)

                        video.currentTime = 1 // seek 2 seconds into the video
                    }

                    function onSeeked () {
                        video.removeEventListener('seeked', onSeeked)

                        const frame = captureFrame(video)

                        // unload video element, to prevent memory leaks
                        video.pause()
                        video.src = ''
                        video.load()

                        // show the captured image in the DOM
                        vm.files.push({type: 'video', url: window.URL.createObjectURL(new window.Blob([frame.image]))});
                    }
                } else {
                    this.files.push({type: 'image', url: URL.createObjectURL(file)});
                }
            });
        },
        createPost(e){
            if(this.form.files.length || this.form.description.length > 5){
                const data = new FormData();
                this.form.files.length ? this.form.files.forEach((file, index) => {
                    data.append('files['+index+']', file);
                }) : data.append('files', this.form.files);
                data.append('description', this.form.description);
                data.append('visibility', this.form.visibility);
                data.append('artista_id', this.artist.artista_id);
                
                this.loading = true;
                axios.post('/api/posts', data,{
                    onUploadProgress: (event) => {
                        this.progress = Math.round(
                            (event.loaded * 100) / event.total
                        );
                    },
                })
                .then(res => {
                    this.dialog = false;
                    EventBus.$emit('reload-posts');
                    this.resetForm();
                });
            }
        },
        resetForm(){
            this.progress = 0;
            this.loading = false;
            this.form.description = '';
            this.form.visibility = 'public';
            this.form.files = [];
            this.files = [];
        },
        handlePhotosClick(){
            this.dialog = true;
            setTimeout(() => {
                this.$refs.fileInput.click();
            }, 100);
        }
    },
}
</script>

<style>
.v-text-field__slot .theme--dark.v-label {
    color: #ffffff4f!important;
}
.v-text-field--filled .v-label, .v-text-field--full-width .v-label {
    top: 16px!important;
}
</style>